
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


export default {
components: {
XHeader,
XInput,
Group,
Cell
},
name: 'orderDetail',
data() {
return {
title: '评论',
orderDetail: {},
address: '',
flag: true
}
},
methods: {
userevaluation() {
this.$router.push({name: 'userevaluation', params: {obj: this.orderDetail}})
}
},
beforeRouteEnter(to, from, next) {
if (from.name == 'normalrepairslist') {
next(vm => {
vm.orderDetail = vm.$route.params.order
vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district
if (vm.orderDetail.isviwo) {
vm.orderDetail.isviwo = '是'
} else {
vm.orderDetail.isviwo = '否'
}
if (vm.orderDetail.sevenday) {
vm.orderDetail.sevenday = '是'
} else {
vm.orderDetail.sevenday = '否'
}
if (!vm.orderDetail.responsible) {
vm.flag = false
}
if (vm.orderDetail.rating) {
vm.title = '查看评论'
}
var order = JSON.stringify(vm.orderDetail)
localStorage.setItem('order', order)
console.log(vm.orderDetail)
})
} else {
next(vm => {
var order = localStorage.getItem('order')
vm.orderDetail = JSON.parse(order)
vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district
if (vm.orderDetail.isviwo) {
vm.orderDetail.isviwo = '是'
} else {
vm.orderDetail.isviwo = '否'
}
if (vm.orderDetail.sevenday) {
vm.orderDetail.sevenday = '是'
} else {
vm.orderDetail.sevenday = '否'
}
if (!vm.orderDetail.responsible) {
vm.flag = false
}
if (vm.orderDetail.rating) {
vm.title = '查看评论'
}
})
}

}
}



// WEBPACK FOOTER //
// ./src/components/normaldone.vue